import '../button.css';
import { ButtonIconProps } from './interface/interface';

export const ButtonIcon = ({
  mode,
  size,
  disabled,
  icon,
  onPress = () => {},
  rounded = true,
  shadow = false,
}: ButtonIconProps) => {
  const Icon = icon;
  const buttonMode = disabled ? 'disabled' : mode;
  const buttonRounded = rounded ? 'rounded' : 'square';
  const shadowClass = shadow ? 'shadow-md shadow-hsecondary-300/40' : '';

  return (
    <button
      className={`h-button--${buttonRounded} h-button--${buttonMode} h-button--icon h-button--icon--${size} h-button--icon--${size}--padding ${shadowClass}`}
      disabled={disabled}
      type="button"
      onClick={onPress}
    >
      <Icon className={`h-button--icon--${size}`} />
    </button>
  );
};
